import { BaseElement } from '@webtides/element-js';

import '../../../elements/price-formatted/price-formatted';

export default class SeriesCard extends BaseElement {
    properties() {
        return {
            frames: {},
            currentFrameId: false,
        };
    }

    watch() {
        return {
            currentFrameId: () => {
                const { url } = this.frames[this.currentFrameId] || {};
                if (url) {
                    this.$refs.image.src = url;
                }
            },
        };
    }
}
